import { tv } from "../../../variants/tv.js";
const logoCloudVariants = tv({
    slots: {
        grid: 'grid items-center justify-items-center gap-8'
    },
    variants: {
        maxColumns: {
            4: {
                grid: '@md:grid-cols-4 grid-cols-2'
            },
            8: {
                grid: '@md:grid-cols-4 @xl:grid-cols-8 grid-cols-2'
            }
        }
    },
    defaultVariants: {
        maxColumns: 4
    }
});
export { logoCloudVariants };
